import { FORTA_WHITE } from '../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';

export const COMMENT_SECTION_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '12px',
  p: 2,
  mb: 3,
  borderRadius: '10px',
  backgroundColor: FORTA_WHITE,
};
